import React, { useEffect, useState } from "react";
import SetupCard from "./SetupCard";
import { getSetupProposals } from "../../api/setupApi";

/* Point-of-bite card: renders the ONE setup proposal for `field` inline on the
   screen where that missing config actually hurts (e.g. business_hours on the
   scheduling page). Shows nothing if that field is already set/confirmed, so it
   silently disappears once handled. This is the durable second entry point
   alongside the dashboard banner — the owner fixes the gap right where they hit
   it, without hunting for a setup screen. */
export default function SetupInlineCard({ field }) {
  const [proposal, setProposal] = useState(null);
  const [hidden, setHidden] = useState(false);

  useEffect(() => {
    let live = true;
    getSetupProposals()
      .then((d) => {
        if (!live) return;
        const match = (d?.proposals || []).find((p) => p.field === field);
        setProposal(match || null);
      })
      .catch(() => { if (live) setProposal(null); });
    return () => { live = false; };
  }, [field]);

  if (hidden || !proposal) return null;

  return (
    <div style={{ marginBottom: 16 }}>
      <SetupCard proposal={proposal} onConfirmed={() => setHidden(true)} />
    </div>
  );
}
